import PropTypes from "prop-types";

import { defineMessages, injectIntl, FormattedMessage } from "react-intl";

import { Helmet } from "react-helmet";

import ImmutablePropTypes from "react-immutable-proptypes";
import ImmutablePureComponent from "react-immutable-pure-component";
import { connect } from "react-redux";

import { debounce } from "lodash";

import ScrollableList from "flavours/glitch/components/scrollable_list";

import { fetchDomainBlocks, expandDomainBlocks } from "../../actions/domain_blocks";
import ColumnHeader from "flavours/glitch/components/column_header";
import PageFrame from "flavours/glitch/features/ui/components/page_frame";
import { LoadingIndicator } from "../../components/loading_indicator";
import DomainContainer from "../../containers/domain_container";





const messages = defineMessages({
  heading: { id: "column.domain_blocks", defaultMessage: "Blocked domains" },
  unblockDomain: { id: "account.unblock_domain", defaultMessage: "Unblock domain {domain}" },
});

const mapStateToProps = state => ({
  domains: state.getIn(["domain_lists", "blocks", "items"]),
  hasMore: !!state.getIn(["domain_lists", "blocks", "next"]),
});

class Blocks extends ImmutablePureComponent {

  static propTypes = {
    params: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    hasMore: PropTypes.bool,
    domains: ImmutablePropTypes.list,
    intl: PropTypes.object.isRequired,
    multiColumn: PropTypes.bool,
    embedded: PropTypes.bool,
  };

  UNSAFE_componentWillMount () {
    this.props.dispatch(fetchDomainBlocks());
  }

  handleLoadMore = debounce(() => {
    this.props.dispatch(expandDomainBlocks());
  }, 300, { leading: true });

  render () {
    const { intl, domains, hasMore, multiColumn, embedded } = this.props;
    const title = intl.formatMessage(messages.heading);

    if (!domains) {
      return (
        <PageFrame embedded={embedded}>
          <LoadingIndicator />
        </PageFrame>
      );
    }

    const emptyMessage = <FormattedMessage id='empty_column.domain_blocks' defaultMessage='There are no blocked domains yet.' />;

    return (
      <PageFrame embedded={embedded} bindToDocument={!multiColumn} label={title}>
        <ColumnHeader icon='network-slash' title={title} multiColumn={multiColumn} showBackButton />

        <ScrollableList
          scrollKey='domain_blocks'
          onLoadMore={this.handleLoadMore}
          hasMore={hasMore}
          emptyMessage={emptyMessage}
          bindToDocument={!multiColumn && !embedded}
        >
          {domains.map(domain =>
            <DomainContainer key={domain} domain={domain} />,
          )}
        </ScrollableList>

        <Helmet>
          <meta name='robots' content='noindex' />
        </Helmet>
      </PageFrame>
    );
  }

}

export default connect(mapStateToProps)(injectIntl(Blocks));
